import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';

export default {
  categories() {
    return Firebase.firestore()
      .collection('categories')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  all(category) {
    return Firebase.firestore()
      .collection('products')
      .where('category', '==', category)
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  manageProduct(product, productCategory) {
    const {
      name,
      brand,
      imageUrl = null,
      active = false,
      category = productCategory.id
    } = product;

    const productObj = {
      name,
      brand,
      imageUrl,
      active,
      category
    };

    const promise = product.docId
      ? Firebase.firestore()
          .collection('products')
          .doc(product.docId)
          .update(productObj)
      : Firebase.firestore()
          .collection('products')
          .add(productObj);

    return promise;
  },

  deleteProduct(product) {
    return Firebase.firestore()
      .collection('products')
      .doc(product)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/products/service.js